<template>
    <v-form
        class="login-form"
        @keyup.enter="enterKeySubmit"
    >
        <v-text-field
            v-model="username"
            label="Όνομα Χρήστη"
            class="form-field"
            required
        />
        <v-text-field
            v-model="password"
            :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
            :type="show ? 'text' : 'password'"
            label="Κωδικός"
            value=""
            class="input-group--focused form-field"
            @click:append="show = !show"
            @keyup.enter="enterKeySubmit"
        />
        <div
            class="submit-button-wrapper"
        >
            <v-btn
                class="login-button"
                color="black"
                :disabled="shouldDisableSubmit()"
                :loading="dialog"
                @click="submit"
            >
                Εισοδος
            </v-btn>
        </div>
    </v-form>
</template>

<script>
    import store from '@/store'
    import userService from '@/services/user'
    import config from '@/services/config'
    import jwtUtil from '@/utils/jwtUtil'

    export default {
        computed: {
            userRoles() {
                return jwtUtil.getRoles(this.$store.getters.getToken)
            },
            isAdmin() {
                return this.containsAny(['ROLE_ADMIN'], this.userRoles)
            }
        },
        data() {
            return {
                show: false,
                dialog: false,
                username: '',
                password: ''
            }
        },
        methods: {
            enterKeySubmit() {
                if (!this.shouldDisableSubmit()) {
                    this.submit()
                }
            },
            shouldDisableSubmit() {
                if (!this.password || !this.username) {
                    return true
                }
                return false
            },
            getConfig() {
                config.getConfig().then(resp => {
                    this.$store.dispatch('setConfig', resp.data).then(() => {
                        if (!this.isAdmin) {
                            this.$router.push('/calendar')
                            return
                        }
                        this.$router.push('/')
                    })
                })
            },
            submit() {
                this.dialog = true
                userService.login({
                    username: this.username.trim(),
                    password: this.password.trim()
                }).then(resp => {
                    this.dialog = false
                    store.dispatch('login', [resp]).then(() => this.getConfig())
                }).catch(error => {
                    let message = ''
                    if (error.response && error.response.status === 503) {
                        message = 'Η υπηρεσία δεν είναι διαθέσιμη αυτή τη στιγμή. Έαν δεν επανέλθει σε 3΄, επικοινωνήστε με τον Διαχειριστή'
                    } else if (error.response.data) {
                        const errorData = error.response.data
                        if (errorData.code === 'USER_NOT_FOUND') {
                            message = 'Το όνομα χρήστη ή ο κωδικός είναι λάθος'
                        } else {
                            message = error.response.data.message
                        }
                    }
                    this.$emit('setAlert', message, 'error')
                    this.dialog = false
                })
            },
            containsAny(arr1, arr2) {
                return arr1.some(item => arr2.includes(item))
            }
        }
    }
</script>

<style scoped>
    .login-button {
        appearance: none;
        background-color: transparent;
        border: 0.125em solid #1A1A1A;
        border-radius: 0.5rem;
        box-sizing: border-box;
        color: #ffffff;
        cursor: pointer;
        display: inline-block;
        font-size: 1rem;
        font-weight: 600;
        line-height: normal;
        margin: 0;
        min-height: 1.75em;
        min-width: 0;
        outline: none;
        padding: 1em 2.3em;
        text-align: center;
        text-decoration: none;
        transition: all 300ms cubic-bezier(.23, 1, 0.32, 1);
        user-select: none;
        -webkit-user-select: none;
        touch-action: manipulation;
        will-change: transform;
    }
    .login-button:disabled {
        pointer-events: none;
        border: 0.125em solid lightgray;
    }

    .login-button:hover {
        color: #fff;
        background-color: #1A1A1A;
        box-shadow: rgba(0, 0, 0, 0.25) 0 8px 15px;
        transform: translateY(-2px);
    }

    .login-button:active {
        box-shadow: none;
        transform: translateY(0);
    }

    .login-form {
        margin-bottom: 5%;
    }
    .form-field {
        width: 90%;
        margin: 0 auto;
    }
    .submit-button-wrapper {
        display: flex;
        justify-content: center;
    }

</style>
